module.exports = __webpack_public_path__ + "img/008.690721c3.png";